import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import logo from "./assets/logo.png"; // ton logo ici

// Ajouter le favicon
const link = document.createElement("link");
link.rel = "icon";
link.type = "image/png";
link.href = logo;
document.head.appendChild(link);

// Using cookie-based sessions; no client-side token setup needed here
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
